<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :inline="true" :model="query" class="search-form">
      <el-form-item label="关键词">
        <el-input v-model="query.keyword" placeholder="店铺名称/编码" clearable @keyup.enter="fetchData" />
      </el-form-item>
      <el-form-item label="平台">
        <el-select v-model="platformFilter" placeholder="请选择平台" clearable @change="fetchData">
          <el-option v-for="item in platformList" :key="item.ID" :label="item.platformName" :value="item.platformCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="statusFilter" placeholder="请选择状态" clearable @change="fetchData">
          <el-option label="Active" value="Active" />
          <el-option label="Inactive" value="Inactive" />
          <el-option label="Expired" value="Expired" />
        </el-select>
      </el-form-item>
      <el-form-item label="启用状态">
        <el-select v-model="enabledFilter" placeholder="请选择" clearable @change="fetchData">
          <el-option label="启用" :value="true" />
          <el-option label="禁用" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="fetchData">查询</el-button>
        <el-button icon="Refresh" @click="resetSearch">重置</el-button>
        <el-button type="success" icon="Plus" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格区域 -->
    <basic-table :query="query" @handler="fetchData">
      <template #platformName="{ row }">
        <el-tag type="primary">{{ row.platformName }}</el-tag>
      </template>
      <template #shopType="{ row }">
        <el-tag>{{ row.shopType }}</el-tag>
      </template>
      <template #status="{ row }">
        <el-tag>{{ row.status }}</el-tag>
      </template>
      <template #autoSyncOrder="{ row }">
        <el-tag :type="row.autoSyncOrder ? 'success' : 'info'">{{ row.autoSyncOrder ? '是' : '否' }}</el-tag>
      </template>
      <template #isEnabled="{ row }">
        <el-switch v-model="row.isEnabled" @change="handleStatusToggle(row)" />
      </template>
      <template #toolbar="{ row }">
        <el-button link type="primary" size="small" icon="View" @click="handleView(row)">查看</el-button>
        <el-button link type="primary" size="small" icon="Edit" @click="handleEdit(row)">编辑</el-button>
        <el-button link type="danger" size="small" icon="Delete" @click="handleDelete(row)">删除</el-button>
      </template>
    </basic-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="900px" @close="handleDialogClose">
      <el-form ref="formRef" :model="formData" :rules="formRules" label-width="140px">
        <el-divider content-position="left">基本信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="平台配置" prop="platformConfigID">
              <el-select v-model="formData.platformConfigID" placeholder="请选择平台" style="width: 100%" @change="handlePlatformSelect">
                <el-option v-for="item in platformList" :key="item.id" :label="item.platformName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺编码" prop="shopCode">
              <el-input v-model="formData.shopCode" placeholder="唯一编码" :disabled="isEdit" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="店铺名称" prop="shopName">
              <el-input v-model="formData.shopName" placeholder="店铺名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺类型" prop="shopType">
              <el-select v-model="formData.shopType" placeholder="请选择" style="width: 100%">
                <el-option label="旗舰店" value="旗舰店" />
                <el-option label="专营店" value="专营店" />
                <el-option label="专卖店" value="专卖店" />
                <el-option label="自营" value="自营" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="平台店铺ID">
              <el-input v-model="formData.platformShopId" placeholder="平台方的店铺ID" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平台商家ID">
              <el-input v-model="formData.platformSellerId" placeholder="平台方的商家ID" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="平台门店ID">
              <el-input v-model="formData.platformStoreId" placeholder="平台方的门店ID" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">归属信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="归属公司" prop="companyID">
              <el-tree-select v-model="formData.companyID" :data="companys" placeholder="请选择公司" 
               check-strictly :render-after-expand="false" style="width: 100%" 
                @change="handleCompanyChange" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="departmentID">
              <el-tree-select v-model="formData.departmentID" :data="departments" placeholder="请选择部门" 
                clearable check-strictly :render-after-expand="false" style="width: 100%" 
                @change="handleDepartmentChange" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="默认仓库编码">
              <el-input v-model="formData.defaultWarehouseCode" placeholder="默认发货仓库编码" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认仓库名称">
              <el-input v-model="formData.defaultWarehouseName" placeholder="仓库名称" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">同步配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="自动同步订单">
              <el-switch v-model="formData.autoSyncOrder" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="同步间隔(分钟)">
              <el-input-number v-model="formData.syncOrderInterval" :min="1" :max="1440" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">联系信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="联系人">
              <el-input v-model="formData.contactName" placeholder="联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <el-input v-model="formData.contactPhone" placeholder="联系电话" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系邮箱">
              <el-input v-model="formData.contactEmail" placeholder="联系邮箱" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">其他信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="formData.status" placeholder="请选择" style="width: 100%">
                <el-option label="Active" value="Active" />
                <el-option label="Inactive" value="Inactive" />
                <el-option label="Expired" value="Expired" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用">
              <el-switch v-model="formData.isEnabled" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序码">
              <el-input-number v-model="formData.sortCode" :min="0" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="扩展配置">
          <el-input v-model="formData.extraConfig" type="textarea" :rows="3" placeholder="JSON格式的扩展配置" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="formData.description" type="textarea" :rows="2" placeholder="店铺描述" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.remark" type="textarea" :rows="2" placeholder="备注信息" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>

    <!-- 查看详情对话框 -->
    <el-dialog v-model="viewDialogVisible" title="店铺详情" width="900px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="店铺编码">{{ viewData.shopCode }}</el-descriptions-item>
        <el-descriptions-item label="店铺名称">{{ viewData.shopName }}</el-descriptions-item>
        <el-descriptions-item label="店铺类型">{{ viewData.shopType }}</el-descriptions-item>
        <el-descriptions-item label="平台名称">{{ viewData.platformName }}</el-descriptions-item>
        <el-descriptions-item label="平台店铺ID">{{ viewData.platformShopId }}</el-descriptions-item>
        <el-descriptions-item label="平台商家ID">{{ viewData.platformSellerId }}</el-descriptions-item>
        <el-descriptions-item label="平台门店ID">{{ viewData.platformStoreId }}</el-descriptions-item>
        <el-descriptions-item label="归属公司">{{ viewData.companyName }}</el-descriptions-item>
        <el-descriptions-item label="归属部门">{{ viewData.departmentName }}</el-descriptions-item>
        <el-descriptions-item label="默认仓库编码">{{ viewData.defaultWarehouseCode }}</el-descriptions-item>
        <el-descriptions-item label="默认仓库名称">{{ viewData.defaultWarehouseName }}</el-descriptions-item>
        <el-descriptions-item label="自动同步订单">
          <el-tag :type="viewData.autoSyncOrder ? 'success' : 'info'">{{ viewData.autoSyncOrder ? '是' : '否' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="同步间隔">{{ viewData.syncOrderInterval }} 分钟</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ viewData.contactName }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ viewData.contactPhone }}</el-descriptions-item>
        <el-descriptions-item label="联系邮箱">{{ viewData.contactEmail }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag>{{ viewData.status }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="是否启用">
          <el-tag :type="viewData.isEnabled ? 'success' : 'danger'">{{ viewData.isEnabled ? '启用' : '禁用' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="排序码">{{ viewData.sortCode }}</el-descriptions-item>
        <el-descriptions-item label="扩展配置" :span="2">{{ viewData.extraConfig }}</el-descriptions-item>
        <el-descriptions-item label="描述" :span="2">{{ viewData.description }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ viewData.remark }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ this.$util.fmtDate(viewData.createDate) }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ viewData.createUserName }}</el-descriptions-item>
        <el-descriptions-item label="修改时间">{{ this.$util.fmtDate(viewData.updateDate) }}</el-descriptions-item>
        <el-descriptions-item label="修改人">{{ viewData.updateUserName }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import BasicTable from '@/components/basic-table.vue'
import { getEnabledPlatformList } from '@/api/platform'

export default {
  name: 'PlatformShop',
  components: {
    BasicTable
  },
  data() {
    return {
      query: {
        keyword: '',
        filters: [],
        sidx: 'CreateDate',
        sord: 'descending',
        page: 1,
        rows: 20,
        data: [],
        columns: [
          { type: 'selection', width: '55' },
          { type: 'index', label: '序号', width: '60' },
          { prop: 'shopCode', label: '店铺编码', width: '150', sortable: true, searchable: true },
          { prop: 'shopName', label: '店铺名称', width: '180', sortable: true, searchable: true },
          { type: 'template', prop: 'shopType', label: '店铺类型', width: '110' },
          { type: 'template', prop: 'platformName', label: '所属平台', width: '130' },
          { prop: 'companyName', label: '归属公司', width: '180', showOverflowTooltip: true },
          { prop: 'departmentName', label: '归属部门', width: '150', showOverflowTooltip: true },
          { prop: 'defaultWarehouseName', label: '默认仓库', width: '130' },
          { type: 'template', prop: 'autoSyncOrder', label: '自动同步', width: '90' },
          { type: 'template', prop: 'status', label: '状态', width: '100' },
          { type: 'template', prop: 'isEnabled', label: '启用', width: '80' },
          { prop: 'createDate', label: '创建时间', width: '160', sortable: true },
          { type: 'toolbar', label: '操作', width: '220', fixed: 'right' }
        ]
      },
      platformFilter: '',
      statusFilter: '',
      enabledFilter: '',
      platformList: [],
      companys: [],
      departments: [],
      dialogVisible: false,
      viewDialogVisible: false,
      isEdit: false,
      formData: {},
      viewData: {},
      formRules: {
        platformConfigID: [{ required: true, message: '请选择平台配置', trigger: 'change' }],
        shopCode: [
          { required: true, message: '请输入店铺编码', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1-50 之间', trigger: 'blur' }
        ],
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1-100 之间', trigger: 'blur' }
        ],
        shopType: [{ required: true, message: '请选择店铺类型', trigger: 'change' }],
        companyID: [{ required: true, message: '请选择归属公司', trigger: 'change' }],
        departmentID: [{ required: true, message: '请选择归属部门', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑店铺' : '新增店铺'
    }
  },
  mounted() {
    this.$kaung.init(this.$options.name)
    this.loadPlatformList()
    this.loadCompanyList()
    this.fetchData()
  },
  methods: {
    builder() {
      let { data, records, total, ...params } = { ...this.query }
      
      // 重置并添加筛选条件
      params.filters = []
      if (this.platformFilter) {
        params.filters.push({ name: 'platformCode', value: this.platformFilter, operate: 0 })
      }
      if (this.statusFilter) {
        params.filters.push({ name: 'status', value: this.statusFilter, operate: 0 })
      }
      if (this.enabledFilter !== '') {
        params.filters.push({ name: 'isEnabled', value: this.enabledFilter, operate: 0 })
      }
      return params
    },
    fetchData() {
      this.$kaung.search(this.builder()).then(res => {
        this.query = { ...res.data }
      })
    },
    resetSearch() {
      this.query.keyword = ''
      this.platformFilter = ''
      this.statusFilter = ''
      this.enabledFilter = ''
      this.fetchData()
    },
    loadPlatformList() {
      getEnabledPlatformList().then(res => {
        this.platformList = res.data || []
      })
    },
    loadCompanyList() {
      this.$kaung.companys().then(res => {
        this.companys = res || []
      })
    },
    loadDepartmentList(companyID) {
      if (!companyID) {
        this.departments = []
        return
      }
      this.$kaung.departments(companyID).then(res => {
        this.departments = res || []
      })
    },
    handlePlatformSelect(platformConfigID) {
      const platform = this.platformList.find(p => p.id === platformConfigID)
      if (platform) {
        this.formData.platformCode = platform.platformCode
        this.formData.platformName = platform.platformName
      }
    },
    handleCompanyChange(companyID) {
      this.formData.departmentID = ''
      this.loadDepartmentList(companyID)
    },
    handleDepartmentChange() {
      // 部门选择变更
    },
    handleAdd() {
      this.isEdit = false
      this.formData = {
        platformConfigID: '',
        platformCode: '',
        platformName: '',
        shopCode: '',
        shopName: '',
        shopType: '',
        platformShopId: '',
        platformSellerId: '',
        platformStoreId: '',
        companyID: '',
        companyName: '',
        departmentID: '',
        departmentName: '',
        defaultWarehouseCode: '',
        defaultWarehouseName: '',
        autoSyncOrder: true,
        syncOrderInterval: 30,
        extraConfig: '',
        isEnabled: true,
        status: 'Active',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        description: '',
        remark: '',
        sortCode: 0
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.$kaung.getone(row.id).then(res => {
        this.formData = { ...res.data }
        if (this.formData.companyID) {
          this.loadDepartmentList(this.formData.companyID)
        }
        this.dialogVisible = true
      })
    },
    handleView(row) {
      this.$kaung.getone(row.id).then(res => {
        this.viewData = { ...res.data }
        this.viewDialogVisible = true
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该店铺吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$kaung.delete(row.id).then(() => {
          this.$message.success('删除成功')
          this.fetchData()
        })
      })
    },
    handleStatusToggle(row) {
      this.$kaung.submit({ id: row.id, data: { isEnabled: row.isEnabled } }).then(() => {
        this.$message.success('状态更新成功')
      }).catch(() => {
        row.isEnabled = !row.isEnabled
      })
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        
        const submitData = { ...this.formData }
        // 移除只读字段
        delete submitData.deleteMark
        delete submitData.createDate
        delete submitData.createUserName
        delete submitData.updateDate
        delete submitData.updateUserName
        
        this.$kaung.submit({ id: submitData.id, data: submitData }).then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchData()
        })
      })
    },
    handleDialogClose() {
      this.$refs.formRef?.resetFields()
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.search-form {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}
</style>
